module.exports = __webpack_public_path__ + "img/20191206165901158.02c6a7a0.jpg";